import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

export default function HomeClass() {
    const [activeKey, setActiveKey] = useState("brand-tab1");
    const [isHovered, setIsHovered] = useState(false); 

  return (
    <>
    <section className="homeclass-area">
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
              <Tab.Container activeKey={activeKey}>
                <div className="position-relative">
                    <div className="classtab-head">
                        <p>We Want you to</p>
                        <h4 className="heading wow animate__animated animate__slideInUp">be supported every step of the way</h4>
                    </div>
                

                    <div className="class-tabarea">
                        <Nav className="classtab-link">
                            <Nav.Item>
                                <Nav.Link href={""} onMouseEnter={() => { setActiveKey("brand-tab1"); setIsHovered(true);}} onMouseLeave={() => setIsHovered(false)}>
                                    <h4>Pre-Primary</h4>
                                    <div>
                                        <span>Year 3 - Year 5+</span>
                                        <img src="/image/class-arrow.svg" alt="arrow"/>
                                    </div>
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link href={""} onMouseEnter={() => { setActiveKey("brand-tab2"); setIsHovered(true);}} onMouseLeave={() => setIsHovered(false)}>
                                    <h4>Primary</h4>
                                    <div>
                                        <span>Year 6 - Year 10+</span>
                                        <img src="/image/class-arrow.svg" alt="arrow"/>
                                    </div>
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link href={""} onMouseEnter={() => { setActiveKey("brand-tab3"); setIsHovered(true);}} onMouseLeave={() => setIsHovered(false)}>
                                    <h4>Junior</h4>
                                    <div>
                                        <span>Year 11 - Year 13+</span>
                                        <img src="/image/class-arrow.svg" alt="arrow"/>
                                    </div>
                                </Nav.Link>
                            </Nav.Item>

                            <Nav.Item>
                                <Nav.Link href={""} onMouseEnter={() => { setActiveKey("brand-tab4"); setIsHovered(true);}} onMouseLeave={() => setIsHovered(false)}>
                                    <h4>Senior</h4>
                                    <div>
                                        <span>Year 14 - Year 17+</span>
                                        <img src="/image/class-arrow.svg" alt="arrow"/>
                                    </div>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content className={`classtab-content ${isHovered ? "activetab" : ""}`}>
                            <Tab.Pane eventKey="brand-tab1">
                                <img src="/image/school-class-1.webp" className="img-responsive" alt="school"/>
                            </Tab.Pane>

                            <Tab.Pane eventKey="brand-tab2">
                                <img src="/image/school-class-2.webp" className="img-responsive" alt="school"/>
                            </Tab.Pane>

                            <Tab.Pane eventKey="brand-tab3">
                                <img src="/image/school-class-3.webp" className="img-responsive" alt="school"/>
                            </Tab.Pane>

                            <Tab.Pane eventKey="brand-tab4">
                                <img src="/image/school-class-4.webp" className="img-responsive" alt="school"/>
                            </Tab.Pane>
                        </Tab.Content>
                    </div>
                </div>
              </Tab.Container>
            </div>

          </div>
        </div>
    </section>
    </>
  )
}
